export const LANGUAGES = [
    { label: 'English (US)', key: 'en-US', direction: "ltr" },
    { label: 'English (UK)', key: 'en-GB', direction: "ltr" },
    { label: 'Spanish (ES)', key: 'es-ES', direction: "ltr" },
    { label: 'Spanish (MX)', key: 'es-MX', direction: "ltr" },
    { label: 'French (FR)', key: 'fr-FR', direction: "ltr" },
    { label: 'French (CA)', key: 'fr-CA', direction: "ltr" },
    { label: 'German', key: 'de-DE', direction: "ltr" },
    { label: 'Italian', key: 'it-IT', direction: "ltr" },
    { label: 'Portuguese (PT)', key: 'pt-PT', direction: "ltr" },
    { label: 'Portuguese (BR)', key: 'pt-BR', direction: "ltr" },
    { label: 'Dutch', key: 'nl-NL', direction: "ltr" },
    { label: 'Danish', key: 'da-DK', direction: "ltr" },
    { label: 'Swedish', key: 'sv-SE', direction: "ltr" },
    { label: 'Norwegian', key: 'no-NO', direction: "ltr" },
    { label: 'Finnish', key: 'fi-FI', direction: "ltr" },
    { label: 'Polish', key: 'pl-PL', direction: "ltr" },
    { label: 'Turkish', key: 'tr-TR', direction: "ltr" },
    { label: 'Russian', key: 'ru-RU', direction: "ltr" },
    { label: 'Arabic (SA)', key: 'ar-SA', direction: "rtl" },
    { label: 'Hebrew', key: 'he-IL', direction: "rtl" },
    { label: 'Chinese (CN)', key: 'zh-CN', direction: "ltr" },
    { label: 'Chinese (TW)', key: 'zh-TW', direction: "ltr" },
    { label: 'Japanese', key: 'ja-JP', direction: "ltr" },
    { label: 'Korean', key: 'ko-KR', direction: "ltr" },
    { label: 'Hindi', key: 'hi-IN', direction: "ltr" },
    { label: 'Thai', key: 'th-TH', direction: "ltr" },
    { label: 'Vietnamese', key: 'vi-VN', direction: "ltr" },
    { label: 'Indonesian', key: 'id-ID', direction: "ltr" },
    { label: 'Malay', key: 'ms-MY', direction: "ltr" },
    { label: 'Greek', key: 'el-GR', direction: "ltr" },
    { label: 'Czech', key: 'cs-CZ', direction: "ltr" },
    { label: 'Hungarian', key: 'hu-HU', direction: "ltr" },
    { label: 'Romanian', key: 'ro-RO', direction: "ltr" },
    { label: 'Slovak', key: 'sk-SK', direction: "ltr" },
    { label: 'Ukrainian', key: 'uk-UA', direction: "ltr" },
    { label: 'Bulgarian', key: 'bg-BG', direction: "ltr" },
]
